import React from "react";

const Twitter = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M34 8.052a13.77 13.77 0 01-3.78 1.027 6.478 6.478 0 002.886-3.595 13.18 13.18 0 01-4.16 1.574A6.6 6.6 0 0024.154 5c-3.632 0-6.556 2.923-6.556 6.506 0 .515.044 1.011.152 1.483A18.622 18.622 0 014.228 6.186a6.506 6.506 0 00-.898 3.287 6.5 6.5 0 002.914 5.406 6.521 6.521 0 01-2.964-.801v.071c0 3.16 2.274 5.786 5.256 6.391a6.599 6.599 0 01-1.72.214c-.42 0-.844-.024-1.242-.11a6.616 6.616 0 006.13 4.53 13.254 13.254 0 01-8.134 2.774 12.38 12.38 0 01-1.57-.09c2.906 1.859 6.35 2.92 10.064 2.92 12.072 0 18.672-9.915 18.672-18.509 0-.287-.01-.565-.024-.84A13.026 13.026 0 0034 8.052z"
            fill={fill}
        />
    </svg>
);

export default Twitter;
